import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Conversation: A threaded exchange between users and agents, consisting of multiple messages over time.',
    name: 'Conversations',
    partialId: PartialId.Standard.create('conversations'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
